// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1lERL","footer":"ChangeClinic_footer__3EOXv"};